import { AxiosRequestConfig } from 'axios';
import { MfaAuthVO, PasswordReset, UserCreate, UserDelete, UserGet, UserGroupsVO, UserProfile, UserTwoFaCode , IResetPasswordLogged, IAcceptDeviceVO, IUserPrivilegeVO, AddingUserGuestVO} from "../model/UserModel";
import { Api, ApiAuth, ApiWithoutToken } from "../services/api";

export async function CreateUser(userCreate:UserCreate) {
    const request = await Api.post<any>(
        "user",
        userCreate
    );

    return request.data; 
  }
  
  export async function GetUser(userId:string) {
    const request = await Api.get<UserGet>(
        "user/" + userId,
    );

    return request.data; 
  }

  export async function VerifyUserAddingGuest(userAddingEmail: string) {
    const request = await Api.get<boolean>(`user/VerifyUserAddingGuest/${userAddingEmail}`);

    return request.data;
  }

  export async function GetUserByEmail(email:string) {
    const request = await Api.get<UserGet>(
        "user/email/" + email,
    );

    return request.data; 
  }

  export async function GetActualUser(token:string) {
    let config: AxiosRequestConfig={};

    if (config.headers === undefined) {
        config.headers = {};
    }

    config.headers.Authorization = `Bearer ${token}`;
    config.headers.scope = 'greendocs';

    const request = await ApiWithoutToken.get<UserProfile>(
        "user",
        config
    );
    return request.data; 
  }

  export async function SetUserTwofaCode(userTwoFaCode:UserTwoFaCode) {

    const request = await ApiWithoutToken.put<any>(
        "twoFa",
        userTwoFaCode
    );
    
    return request.data; 
  }

  export async function EditUser(userCreate:UserCreate) {
    const request = await Api.put<any>(
        "user",
        userCreate
    );

    return request.data; 
  }

  export async function DeleteUser(userDelete:UserDelete) {
    const request = await Api.delete<any>(
        "user",
        {data: userDelete}
    );
  }

  //Groups
  export async function AddUserGroup(userGroup:UserGroupsVO) {
    await Api.put<any>(
        "user/group",
        userGroup
    );
  }

  export async function RemoveUserGroup(userGroup:UserGroupsVO) {
    const request = await Api.delete<any>(
        "user/group",
        {data: userGroup}
    );
  }

  export async function ResetPassword(passwordReset:PasswordReset) {
    const request = await ApiWithoutToken.put<any>(
        "redefinePassword",
        passwordReset
    );

    return request.data; 
  }

  export async function AddingUserGuest(internalName: string, addingUserGuest: AddingUserGuestVO) {
    const request = await Api.put(`user/addingGuest/${internalName}`, addingUserGuest)
    return request.data;
  }

    export async function ResetPasswordLogged(passwordReset:IResetPasswordLogged) {
      const request = await ApiWithoutToken.put<any>(
          "redefinePassword/redefineLogged",
          passwordReset
      );

    return request.data; 
  }

  export async function GetMfaInformation(email: string) {
    const request = await ApiWithoutToken.get<MfaAuthVO>(`user/mfa/${email}`);

    return request.data;
  }

  export async function VerifyOtp(otpCode: string, userEmail: string) {

    let verifyObj = {
      otpCode,
      userId: userEmail
    }

    const request = await ApiWithoutToken.post<MfaAuthVO>(`user/verifyOtp`, verifyObj);

    return request.data;
  }


  export async function SetUserImage(picture: File | undefined) {
    let formData = new FormData();
    formData.append("File", picture!)
    const request = await Api.put<string>(`User/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
        }
    });

    return request.data;
  }

  export async function GetUserPrivilege(userEmail: string, workspaceId: string) {
    const request = await Api.get<IUserPrivilegeVO>(`user/privilege/${userEmail}/${workspaceId}`);
    return request.data;
  }

  export async function SetAcceptNewDevice(input: IAcceptDeviceVO) {
    const request = await ApiAuth.put<any>(`/api/UserInfo/acceptedTrustedDevice`, input)
    return request.data;
  }